import { AddressPOBoxError } from '@components/RouteComponents/AddressPOBoxError'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/address/addressPOBoxError')(
  {
    component: AddressPOBoxError,
  }
)
